import { get, patch } from './client.js';

const base = (orgId) => `/orgs/${orgId}/storage`;

export const orgStorageApi = {
  stats: (orgId) => get(base(orgId)),
  workspaceBreakdown: (orgId) => get(`${base(orgId)}/workspaces`),
  largestFiles: (orgId) => get(`${base(orgId)}/files`),
  recentUploads: (orgId) => get(`${base(orgId)}/uploads`),
  getQuota: (orgId) => get(`${base(orgId)}/quota`),
  updateQuota: (orgId, data) => patch(`${base(orgId)}/quota`, data),
};
